import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sessione-salerno',
  templateUrl: './sessione-salerno.component.html',
  styleUrls: ['./sessione-salerno.component.css']
})
export class SessioneSalernoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
